module.exports = __webpack_public_path__ + "static/shapeRight2-c3284bd460aa447aa18eabf3769bd77a.png";